import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DetailGroupInfo } from 'common/model';

@Component({
    selector: 'app-detail-info-form-page-step',
    templateUrl: './detail-info-form-page-step.component.html',
    styleUrls: ['./detail-info-form-page-step.component.scss'],
    standalone: false
})
export class DetailInfoFormPageStepComponent {

  @Input() form!: FormGroup;
  @Input() detailGroupInfoList: DetailGroupInfo[] = [];

}
